<template>
  <div class="user-detail">
	  <div class="detail-header-part">
			<p>保護者様情報</p>
		</div>
		<div class="detail-top-part">
			<p class="left">
				<img v-bind:src="user | avatar500" @click="modalOpen"/>
				<b-button ref="modal_btn" v-b-modal.modal-scrollable class="dis-none"></b-button>
			</p>
			<div class="right">
				<b-table-simple stacked>
					<b-tbody>
						<b-tr>
							<b-td stacked-heading="名前" v-if="!!user.name">{{ user.name }}</b-td>
							<b-td stacked-heading="年齢" v-if="!!user.age">{{ user.age }}</b-td>
							<b-td stacked-heading="ID" v-if="!!user.email">{{ user.email }}</b-td>
							<b-td stacked-heading="電話番号" v-if="!!user.phone">{{ user.phone }}</b-td>
							<b-td stacked-heading="自宅郵便番号" v-if="!!user.parent.postal_code">{{ user.parent.postal_code }}</b-td>
							<b-td stacked-heading="自宅住所" v-if="!!user.parent.address">{{ user.parent.address }}</b-td>
							<b-td stacked-heading="最寄駅" v-if="!!user.parent.station">{{ user.parent.station.name }}</b-td>
							<b-td stacked-heading="駅までの所要時間　バス" v-if="!!user.parent.bus_time">{{ user.parent.bus_time.name }}</b-td>
							<b-td stacked-heading="駅までの所要時間　徒歩" v-if="!!user.parent.walk_time">{{ user.parent.walk_time.name }}</b-td>
							<b-td stacked-heading="緊急連絡先 名前" v-if="!!user.parent.emgcy_name">{{ user.parent.emgcy_name }}</b-td>
							<b-td stacked-heading="緊急連絡先 電話番号" v-if="!!user.parent.emgcy_phone">{{ user.parent.emgcy_phone }}</b-td>
							<b-td stacked-heading="緊急連絡先 お子様との関係位" v-if="!!user.parent.emgcy_relation">{{ user.parent.emgcy_relation }}</b-td>
							<b-td stacked-heading="登録日">{{ user.created_at | formatDateTime }}</b-td>
							<b-td stacked-heading="最終ログイン">{{ user.last_login_at | formatDateTime }}</b-td>
							<b-td stacked-heading="ログイン回数">{{ user.login_count }}</b-td>
							<b-td stacked-heading="自己紹介" v-if="!!user.parent.description">{{ user.parent.description }}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
			<div class="control-bar">
				<div class="btn-group">
					<b-button @click="user.admin_blocked == 0 ? hide() : show()">{{ user.admin_blocked == 0 ? '非表示' : '表示'}}</b-button>
					<b-button @click="remove" class="red">消去</b-button>
				</div>
				<div class="children-info" v-if="babies.length > 0">
					<h4>お子様情報</h4>
					<div class="child-item"
						v-for="(baby, index) in babies"
						:key="index">
						<p class="child-avatar">
							<img v-bind:src="baby.photo.url"/>
						</p>
						<b-table-simple stacked>
							<b-tbody>
								<b-tr>
									<b-td stacked-heading="名前">{{ baby.name }}</b-td>
									<b-td stacked-heading="生年月日">{{ baby.birthday | formatDate }}</b-td>
									<b-td stacked-heading="愛称">{{ baby.nick_name }}</b-td>
									<b-td stacked-heading="体重">{{ baby.weight }}kg</b-td>
									<b-td stacked-heading="身長">{{ baby.height }}cm</b-td>
									<b-td stacked-heading="ご紹介">{{ baby.description }}</b-td>
									<b-td stacked-heading="アレルギー">{{ baby.allergy }}</b-td>
									<b-td stacked-heading="持病・特別なケア">{{ baby.disease }}</b-td>
									<b-td stacked-heading="その他">{{ baby.extra }}</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
				</div>
			</div>
		</div>
		<b-modal id="modal-scrollable" class="avatar-modal" ok-title="確認" cancel-title="キャンセル">
			<div>
				<img v-bind:src="user | originalPhoto"/>
			</div>
		</b-modal>
  </div>
</template>
<script>
import apiClient from '../../backend'

export default {
  methods: {
		modalOpen() {
			this.$refs.modal_btn.click()
		},
		hide() {
			apiClient.updateUser({ 
				user_id: this.$route.params.id,
				admin_blocked: 1
			}).then(response => {
				this.$router.go(-1)
			})
		},
		show() {
			apiClient.updateUser({ 
				user_id: this.$route.params.id,
				admin_blocked: 0
			}).then(response => {
				this.$router.go(-1)
			})
		},
		remove() {
			apiClient.deleteUser({ 
				id: this.$route.params.id 
			}).then(response => {
				this.$router.go(-1)
			})
		}
  },
  data () {
    return {
			user: {
				parent: {}
			},
			babies: []
    }
  },
  components: {
  },
  mounted () {
		apiClient.getUser({ id: this.$route.params.id }).then(response => {
			this.user = response
			console.log(response)
			if (response.parent.babies) this.babies = response.parent.babies
		})
  },
}
</script>
